module.exports = {
  siteTitle: "DDR", // <title>
  shortSiteTitle: "División de Desarrollo Regional - App", // <title> ending for posts and pages
  siteDescription: "Sistema integrado de actividades y solicitudes",
  // pathPrefix: "",
  siteUrl: "https://amg-manager.subdere.gov.cl",
  siteImage: "preview.jpg",
  siteLanguage: "es",

  /* author */
  authorName: "Welinux",
  authorTwitterAccount: "welinux",

  /* info */
  headerTitle: "",
  headerSubTitle: "",

  /* manifest.json */
  manifestName: "DDR - Aplicación de gestión",
  manifestShortName: "DDR", // max 12 characters
  manifestStartUrl: "/index.html",
  manifestBackgroundColor: "#141f32",
  manifestThemeColor: "#666",
  manifestDisplay: "standalone",

  // gravatar
  // Use your Gravatar image. If empty then will use src/images/jpg/avatar.jpg
  // Replace your email adress with md5-code.
  // Example https://www.gravatar.com/avatar/g.strainovic@gmail.com ->
  // gravatarImgMd5: "https://www.gravatar.com/avatar/1db853e4df386e8f699e4b35505dd8c6",
  gravatarImgMd5: "",

  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/welinux" },
    { name: "twitter", url: "https://twitter.com/welinux" },
    { name: "facebook", url: "http://facebook.com/welinux" }
  ],
  reactSite: process.env.GATSBY_APP_WEBSITE
    ? process.env.GATSBY_APP_WEBSITE
    : "http://amg-manager-app.subdere.gov.cl"
};
